function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 18C13.9704 18 18 13.9704 18 9C18 4.02963 13.9704 0 9 0C4.02963 0 0 4.02963 0 9C0 13.9704 4.02963 18 9 18Z",
  fill: "#D6E826"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 15.1578C4.51421 15.1578 0.805737 11.8723 0.122684 7.57886C0.0492631 8.04307 0 8.51533 0 8.99991C0 13.9703 4.02963 17.9999 9 17.9999C13.9704 17.9999 18 13.9703 18 8.99991C18 8.51533 17.9507 8.04307 17.8773 7.57886C17.1943 11.8723 13.4858 15.1578 9 15.1578Z",
  fill: "#C8D924"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3001 14.2509C14.2415 13.3955 12.7897 11.3648 12.7897 9.00061C12.7897 6.63646 14.2415 4.60577 16.3001 3.7503C16.1097 3.48551 15.9046 3.23351 15.6867 2.99146C13.4206 4.0473 11.8423 6.3404 11.8423 9.00061C11.8423 11.6608 13.4206 13.9539 15.6867 15.0098C15.9041 14.7677 16.1092 14.5152 16.3001 14.2509Z",
  fill: "#ECEFF1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.31362 2.99146C2.0962 3.23351 1.89109 3.48598 1.7002 3.7503C3.75883 4.60577 5.21067 6.63646 5.21067 9.00061C5.21067 11.3648 3.75883 13.3955 1.7002 14.2509C1.89062 14.5157 2.09572 14.7677 2.31362 15.0098C4.57972 13.9539 6.15804 11.6608 6.15804 9.00061C6.15804 6.3404 4.57972 4.0473 2.31362 2.99146Z",
  fill: "#ECEFF1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3003 14.2495C15.6769 13.9904 15.1099 13.6218 14.6215 13.1704C14.3724 13.3708 14.1133 13.5579 13.8433 13.7313C14.3785 14.2537 15.0005 14.6886 15.6868 15.0083C15.9043 14.7663 16.1094 14.5138 16.3003 14.2495Z",
  fill: "#E1E4E6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.37942 13.1704C2.89058 13.6218 2.32405 13.9904 1.70068 14.2495C1.8911 14.5143 2.09621 14.7663 2.3141 15.0083C3.00047 14.6886 3.62242 14.2537 4.15768 13.7313C3.88768 13.5579 3.6281 13.3708 3.37942 13.1704Z",
  fill: "#E1E4E6"
});

var SvgTennis = function SvgTennis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTennis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tennis.a2767af2.svg";
export { ForwardRef as ReactComponent };